import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { getJydacomAssignmentsOfProject } from '../services/jydacom/getJydacomAssignmentsOfProject.service';

export const loadJydacomAssignmentsOfProject = createAsyncThunk(
  'assignments/loadJydacomAssignmentsOfProject',
  async (projectId, { getState }) => {
    const state = getState();

    const selectedProjectId = selectSelectedProjectId(state);

    const effectiveProjectId = projectId ? projectId : selectedProjectId;

    const projectJydacomAssignments = await getJydacomAssignmentsOfProject(
      effectiveProjectId
    );
    return {
      projectId: effectiveProjectId,
      jydacomAssignments: projectJydacomAssignments,
    };
  }
);
